/**
 * Created by sung on 2017-02-10.
 */
import {Component, Injectable,Input,Output,EventEmitter} from '@angular/core'
import {SelectItem} from "primeng/components/common/api";

import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Injectable()
export class SharedService {
  @Output() table_list: EventEmitter<any> = new EventEmitter();
  @Output() searchIDs :EventEmitter<any> = new EventEmitter();
  @Output() totalRecord :EventEmitter<any> = new EventEmitter();
  private logger : Logger = new Logger();
  constructor() {
    this.logger.debug('shared service started');
  }

  changeTableList(item : any) {
    this.logger.debug('change started');
    this.table_list.emit(item);
  }
  changeSearchIDs(item : SelectItem[]){
    this.searchIDs.emit(item);
  }

  changeTotalRecord(num : number){
    this.totalRecord.emit(num);
  }

  getTableList() {
    return this.table_list;
  }
  getSearchIDs(){
    return this.searchIDs;
  }

  getTotalRecord(){
    return this.totalRecord;
  }
}




// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/service/shared_service.ts